"use client";

import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
function DesktopMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-20 bg-muted animate-pulse rounded" />)}
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-0">
        {menuItems.map((item, index) => <React.Fragment key={item.id}>
            <NavigationMenuItem>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="group relative px-4 py-2 text-sm font-medium text-foreground transition-colors hover:text-primary">
                  {item.label}
                  <span className="absolute bottom-0 left-1/2 h-[2px] w-0 -translate-x-1/2 bg-primary transition-all duration-300 group-hover:w-full" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>
            {index < menuItems.length - 1 && <li className="h-4 self-center" aria-hidden="true">
                <Separator orientation="vertical" className="h-full bg-border/50" />
              </li>}
          </React.Fragment>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 p-6">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-6 w-32 bg-muted animate-pulse rounded" />)}
      </div>;
  }
  return <nav className="flex flex-col p-6 space-y-4">
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-lg font-medium text-foreground hover:text-primary transition-colors border-b border-border/30 pb-2" onClick={onClose}>
          {item.label}
        </Link>)}
      <div className="pt-4">
        <Button className="w-full" asChild>
          <Link to="/SchedulingPage">Agendar Consulta</Link>
        </Button>
      </div>
    </nav>;
}
export default function Cabecalho() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full transition-all duration-500 border-b ${isScrolled ? "bg-background/80 backdrop-blur-[15px] border-border/40 shadow-sm" : "bg-background border-transparent shadow-none"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex h-20 items-center justify-between">
          {}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center gap-2">
              <img src="https://dilsaudecapilar.com.br/wp-content/uploads/2026/02/dil2.png" alt="Dil Saúde Capilar Logo" className="object-contain !w-[200px] !h-[100px]" />
            </Link>
          </div>

          {}
          <div className="hidden md:flex items-center gap-8">
            <MenuProvider menu_id="46" className="hidden md:block">
              <DesktopMenuConsumer />
            </MenuProvider>
            
            <div className="hidden lg:flex items-center gap-4 pl-4 border-l border-border/50">
               <Button variant="default" size="sm" className="rounded-full px-6" asChild>
                <Link to="/SchedulingPage">Agendar</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="md:hidden">
            <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>
      </div>

      {}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-background/95 backdrop-blur-xl border-b border-border shadow-lg animate-in slide-in-from-top-5 duration-300">
          <MenuProvider menu_id="46">
            <MobileMenuConsumer onClose={() => setIsMobileMenuOpen(false)} />
          </MenuProvider>
        </div>}
    </header>;
}